var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.126,
    height: 31.5,
    viewBox: "0 0 22.126 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #00b0a9;\n        stroke-linecap: round;\n        stroke-width: 1.5px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10245",
    "data-name": "Group 10245",
    transform: "translate(6418.25 19366.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7290",
    "data-name": "Path 7290",
    className: "cls-1",
    d: "M10.659,12.036l3.419-3.312a1.311,1.311,0,0,1,.756-.354,1.343,1.343,0,0,1,1.105.352l3.42,3.313",
    transform: "translate(-6416.233 -19364.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7291",
    "data-name": "Path 7291",
    className: "cls-1",
    d: "M13.171,6.343A3.171,3.171,0,1,0,10,3.171,3.171,3.171,0,0,0,13.171,6.343Z",
    transform: "translate(-6414.312 -19365.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7295",
    "data-name": "Path 7295",
    className: "cls-1",
    d: "M13.906,7.813A3.906,3.906,0,1,0,10,3.906,3.906,3.906,0,0,0,13.906,7.813Z",
    transform: "translate(-6427.5 -19365.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7296",
    "data-name": "Path 7296",
    className: "cls-1",
    d: "M13.906,7.813A3.906,3.906,0,1,0,10,3.906,3.906,3.906,0,0,0,13.906,7.813Z",
    transform: "translate(-6427.5 -19343.748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7297",
    "data-name": "Path 7297",
    className: "cls-1",
    d: "M17.805,9.9c0,.1.044,2.924,0,3.429a5.109,5.109,0,0,1-5.162,4.509H5.559",
    transform: "translate(-6419.076 -19366.23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7298",
    "data-name": "Path 7298",
    className: "cls-2",
    d: "M0,1V14.073",
    transform: "translate(-6413.594 -19358.557)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvHover);
export default __webpack_public_path__ + "static/media/iv-hover.b19bece302b1c11fe6ffab4613bb1d3a.svg";
export { ForwardRef as ReactComponent };